import {
  fetchPost, fetchDelete, fetchPatch, fetchEncryptGet, // fetchGet,
} from '#providers/Fetch';
import makeHandler from '#services/makeHandler';

const URL = {
  user: 'user',
  // TODO: THIS WILL BE NICE TO HAVE IT ON BACKEND
  // newFetch : id => `user/${id}`, // TODO: On Backend
  // newUpdate: id => `user/${id}`, // TODO: On Backend
  // newDelete: id => `user/${id}`, // TODO: On Backend
};

const fetch = makeHandler(
  async (query = {}) => fetchEncryptGet(URL.user, query),
  { defaultError: 'Error fetching users' }
);

const create = makeHandler(
  async data => fetchPost(URL.user, data),
  { defaultError: 'Error creating user' }
);

const update = makeHandler(
  async (id, data) => fetchPatch(`${URL.user}/${id}`, data),
  { defaultError: 'Error updating the user' }
);

const remove = makeHandler(
  async id => fetchDelete(`${URL.user}/${id}`),
  { defaultError: 'Error updating the user' }
);

// TODO: Future nice to have endpoints
// const newCreate = makeHandler(
//   async data => fetchPost(URL.create, data),
//   { defaultError: 'Error creating the user' }
// );

// const newFetch = makeHandler(
//   async id => fetchGet(URL.fetch(id)),
//   { defaultError: 'Failed to fetch the user' }
// );

// const newUpdate = makeHandler(
//   async (id, data) => fetchPut(URL.update(id), data),
//   { defaultError: 'Error updating the user' }
// );

// const newRemove = makeHandler(
//   async (id, data) => fetchDelete(URL.delete(id), data),
//   { defaultError: 'Error updating the user' }
// );

export default {
  create,
  fetch,
  update,
  remove,
};
